export interface IAppConfig {
  LocalStorageKey: Record<string, string>;
  CallbackTokenKey: string;
}

export class AppConfig implements IAppConfig {
  private static _instance: IAppConfig;
  public static get Instance() {
    return this._instance || (this._instance = new this());
  }

  readonly LocalStorageKey = {
    accessToken: "t__joyfull_access_token",
    appToken: "t__joyfull_app_token",
    menusInCart: "t__joyfull_menus_in_cart",
    appliedCoupons: "t__joyfull_applied_coupons",
    unselectedAppCoupons: "t__joyfull_unselected_app_coupons",
    selectedAppCoupons: "t__joyfull_selected_multiple_app_coupons",
    userMemo: "t__joyfull_memo",
    campaign: "t__joyfull_campaign",
    viewedTermsOfUse: "t__joyfull_viewed_terms_of_use",
    pickupInfo: "t__joyfull_pickup_info",
    isIgnoreMaintenance: "t__joyfull_ignore_maintenance",
  };

  readonly CallbackTokenKey = "token";

  readonly CookieKey = {
    selectedLang: "wovn_selected_lang",
  };
}
